module.exports = __webpack_public_path__ + "static/luxy-logo-206931ac19ec4d30de72c727524c907a.png";